module.exports = __webpack_public_path__ + "static/img/love.c7aa3bb2.png";